import { render, staticRenderFns } from "./inputMoney.vue?vue&type=template&id=01129a1b&scoped=true"
import script from "./inputMoney.vue?vue&type=script&lang=js"
export * from "./inputMoney.vue?vue&type=script&lang=js"
import style0 from "./inputMoney.vue?vue&type=style&index=0&id=01129a1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01129a1b",
  null
  
)

export default component.exports